import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import { withRouter } from "react-router-dom";
import "jquery-ui-bundle/jquery-ui.css";
import "../../assets/css/style.css";
import swal from "sweetalert";
import $ from "jquery";
import "jquery-ui-bundle";
import { connect } from "react-redux";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from "../../Server";
import axios from "axios";
import { HomeIcon } from "../../assets/Icons";
import { isMobile } from "../../common/MobileView";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import BackBtn from "../../common/BackBtn";
var version_info = JSON.parse(sessionStorage.getItem("version_info"));
var workflowDetails = JSON.parse(sessionStorage.getItem("selected_workflow_description"));

const initialState = {
  bankSelected: false,
  p_c_question_type: "",
  question_pc_bank: "",
  selectionType: "none",
  SelectedBankTypeForCreateBank: "",
  createBank: false,
  selectedMcqBankIdForTask: "",
  selectedRangeBankIdForTask: "",
  selectedParentChildBankIdForTask: "",
  selectedBank: "",
  // Mcq Question Bank State
  quectionMcq: "",
  correctAnsMcq: "",
  alt1AnsMcq: "",
  alt2AnsMcq: "",
  alt3AnsMcq: "",
  McqTypeBank: "",
  mcqIsMandatry: false,

  // Range Question Bank State
  quectionRange: "",
  minRange: "",
  maxRange: "",
  rangeIsMandatry: false,
  //bank list

  isMandatryCheck: false,
  selectedNodeIDForPC: undefined,

  // SubTask  "none", "next"
  subtask_type: "none",
  selectedRadioTaskLevel2: "",
  option_type_task_L2: "",
  clicked_task_L2: "",
  isMandatryCheckL2: false,

  createBankRangeOnP_C: false,
  createBankMcqOnP_C: false,
  editMode: 0,
  editJson: {},
  publishLoader: false,
  publishPopup: false,
};

class CreateTaskBank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bankSelected: false,
      p_c_question_type: "",
      question_pc_bank: "",
      allTasks: [],
      listParentChild: [],
      selectionType: "none",
      SelectedBankTypeForCreateBank: "",
      createBank: false,
      selectedMcqBankIdForTask: "",
      selectedRangeBankIdForTask: "",
      selectedParentChildBankIdForTask: "",
      selectedBank: "",

      // Mcq Question Bank State
      quectionMcq: "",
      correctAnsMcq: "",
      alt1AnsMcq: "",
      alt2AnsMcq: "",
      alt3AnsMcq: "",
      McqTypeBank: "",
      mcqIsMandatry: false,

      // Range Question Bank State
      quectionRange: "",
      minRange: "",
      maxRange: "",
      rangeIsMandatry: false,
      //bank list
      mcqBankList: [],
      rangeBankList: [],
      parentChildBankList: [],
      isMandatryCheck: false,
      selectedNodeIDForPC: undefined,

      // SubTask  "none", "next"
      subtask_type: "none",
      tasksListForTrigger: [],
      selectedRadioTaskLevel2: "",
      option_type_task_L2: "",
      clicked_task_L2: "",
      isMandatryCheckL2: false,
      createBankRangeOnP_C: false,
      createBankMcqOnP_C: false,
      message: "",

      // Edit Tasks
      editMode: 0,
      editJson: {},
      publishLoader: false,
    };
  }

  addParentChild = (node) => {
    this.setState({ selectedNodeIDForPC: node.id });
  };

  componentWillMount() {
    if (
      sessionStorage.getItem("selected_workflow") == null ||
      sessionStorage.getItem("selected_workflow") == undefined ||
      sessionStorage.getItem("selected_workflow") === ""
    ) {
      this.props.history.push("/create/workflow");
      return;
    }
  }

  selectedMcqType = (e) => {
    this.setState({ McqTypeBank: e.target.value });
  };
  selectedEdit = (e) => {
    this.setState({ McqTypeBankEdit: e.target.value });
  };
  selectedBank = (e) => {
    this.setState({ selectedBank: e.target.value });
    if (e.target.value === "MCQ") {
      this.fetchMcqBankList();
    } else if (e.target.value === "Range") {
      this.fetchRangeBankList();
    } else if (e.target.value === "ParentChild") {
      this.fetchParentChildBankList();
    }
  };

  resetAllState = () => {
    this.setState(initialState);
  };
  onChangeInputCreateParent = (e) => {
    this.setState({ p_c_question_type: e.target.value });
    if (e.target.value == 1) {
      this.fetchMcqBankList();
    } else if (e.target.value == 2) {
      this.fetchRangeBankList();
    } else if (e.target.value == 3) {
      this.fetchParentChildBankList();
    }
  };
  SaveMcqBank = () => {
    var data;
    var _this = this;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        alternative2: this.state.alt2AnsMcq,
        alternative3: this.state.alt3AnsMcq,
        is_mandatory: this.state.mcqIsMandatry,
        version_id: version_info.id,
        mcq_type: 1,
      };
    } else {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        is_mandatory: this.state.mcqIsMandatry,
        version_id: version_info.id,
        mcq_type: 2,
      };
    }
    if (this.state.selectionType === "task") {
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };
      axios
        .post(`${SERVER_IP}/workflowTasksMCQ`, data, { withCredentials: true, headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error === false) {
              swal(response.data.message);
              _this.resetAllState();
              _this.fetchTaskList();
            } else {
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveMcqBank();
                }
              });
            }
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.");
        });
    } else if (this.state.selectionType === "subtasklevel2") {
      axios
        .post(`${SERVER_IP}/bank/MCQCreate`, data)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error === false) {
              _this.setState({
                selectedRangeBankIdForTask: response.data.id,
                selectedMcqBankIdForTask: response.data.id,
              });
              _this.AddTaskFromBankLevel2Banks("MCQ", _this.state.mcqIsMandatry);
              return;
            } else {
              auth_response_flow(response.data, (return_response) => {
                if (return_response.error === false && return_response.retry === true) {
                  _this.SaveMcqBank();
                }
              });
            }
            // swal(response.data.message)
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.");
        });
    }
  };

  saveMcqBankDataOnPC = () => {
    var data;
    var _this = this;
    if (this.state.McqTypeBank === "mcq") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        alternative2: this.state.alt2AnsMcq,
        alternative3: this.state.alt3AnsMcq,
        is_mandatory: this.state.mcqIsMandatry,
        mcq_type: 1,
      };
    } else {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        question: this.state.quectionMcq,
        correct: this.state.correctAnsMcq,
        alternative1: this.state.alt1AnsMcq,
        is_mandatory: this.state.mcqIsMandatry,
        mcq_type: 2,
      };
    }

    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/MCQCreate`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            _this.setState({
              createBankMcqOnP_C: false,
              quectionMcq: "",
              correctAnsMcq: "",
              alt1AnsMcq: "",
              alt2AnsMcq: "",
              alt3AnsMcq: "",
              mcqIsMandatry: false,
              McqTypeBank: "",
            });
            _this.fetchMcqBankList();
          }
          swal(response.data.message);
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  SaveRangeBank = () => {
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.quectionRange,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
      is_mandatory: this.state.rangeIsMandatry,
      version_id: version_info.id,
    };
    var _this = this;
    if (this.state.selectionType === "task") {
      axios
        .post(`${SERVER_IP}/workflowTasksRange`, data)
        .then(function (response) {
          if (response.status === 200) {
            swal(response.data.message);
            _this.resetAllState();
            _this.fetchTaskList();
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.");
        });
    } else if (this.state.selectionType === "subtasklevel2") {
      axios
        .post(`${SERVER_IP}/bank/RangeCreate`, data)
        .then(function (response) {
          if (response.status === 200) {
            if (response.data.error == false) {
              _this.setState({
                selectedRangeBankIdForTask: response.data.id,
                selectedMcqBankIdForTask: response.data.id,
              });

              _this.AddTaskFromBankLevel2Banks("Range", _this.state.rangeIsMandatry);
              return;
            }
            swal(response.data.message);
            // _this.setState({ SelectedBankTypeForCreateBank: "" })
            _this.fetchRangeBankList();
          }
        })
        .catch(function (error) {
          swal("Something Went Wrong. Please Retry.");
        });
    }
  };
  saveRangeBankDataOnPC = () => {
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      question: this.state.quectionRange,
      max_value: this.state.maxRange,
      min_value: this.state.minRange,
      is_mandatory: this.state.rangeIsMandatry,
    };
    var _this = this;

    axios
      .post(`${SERVER_IP}/bank/RangeCreate`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.setState({
            createBankRangeOnP_C: false,
            quectionRange: "",
            max_value: "",
            min_value: "",
            is_mandatory: "",
          });
          _this.fetchRangeBankList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  saveParentChildBankForP = () => {
    var data = {
      sid: ud.main_id,
      parent_id: 0,
      question: this.state.question_pc_bank,
      child_type: 3,
      bank_id: 0,
      is_mandatory: 1,
    };

    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.setState({ createBank: false, question_pc_bank: "" });
          _this.fetchParentChildBankList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  saveParentChildBankForC = (child_type) => {
    var data;
    if (child_type == 1) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 1,
        bank_id: this.state.selectedMcqBankIdForTask,
      };
    } else if (child_type == 2) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: "",
        child_type: 2,
        bank_id: this.state.selectedRangeBankIdForTask,
      };
    } else if (child_type == 3) {
      data = {
        sid: ud.main_id,
        parent_id: this.state.selectedNodeIDForPC,
        question: this.state.question_pc_bank,
        child_type: 3,
        bank_id: 0,
        is_mandatory: 1,
      };
    } else {
      return;
    }

    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/ParentChildCreate`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.setState({
            selectedRangeBankIdForTask: "",
            selectedMcqBankIdForTask: "",
            p_c_question_type: null,
            selectedNodeIDForPC: undefined,
          });
          _this.fetchParentChildBankList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  onChangeInput = (e) => {
    e.preventDefault();

    this.setState({ [e.target.name]: e.target.value });
  };
  handleCheckbox = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.checked });
  };

  componentDidMount() {
    // $( function() {
    //     $( "#sortable" ).sortable();
    //     $( "#sortable" ).disableSelection();
    //   } );
    this.fetchTaskList();
  }

  fetchTaskList = () => {
    var data = {
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowTasks`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status.error === false) {
            if (response.data.taskDetails) {
              if (response.data.status.is_published == 0) {
                this.props.history.push("/create/task");
                return;
              }
              _this.setState({
                allTasks: response.data.taskDetails,
                message: response.data.taskDetails.length === 0 ? "No Record Found." : "",
                publishStatus: response.data.status.publish_status == 0 ? "publish" : "unpublish",
              });
            }
          } else {
            auth_response_flow(response.data, (return_response) => {
              if (return_response.error === false && return_response.retry === true) {
                _this.fetchTaskList();
              }
            });
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  drag_start = (event) => {
    var style = window.getComputedStyle(event.target, null);
    event.dataTransfer.setData(
      "text/plain",
      parseInt(style.getPropertyValue("left"), 10) -
        event.clientX +
        "," +
        (parseInt(style.getPropertyValue("top"), 10) - event.clientY) +
        "," +
        event.target.getAttribute("data-item")
    );
  };

  drag_over = (event) => {
    event.preventDefault();
    return false;
  };

  drop = (event) => {
    var offset = event.dataTransfer.getData("text/plain").split(",");
    var dm = document.getElementsByClassName("dragme");
    dm[parseInt(offset[2])].style.left = event.clientX + parseInt(offset[0], 10) + "px";
    dm[parseInt(offset[2])].style.top = event.clientY + parseInt(offset[1], 10) + "px";
    event.preventDefault();
    return false;
  };
  addTask = () => {
    this.resetAllState();
    this.setState({ selectionType: "task" });
  };

  createBank = () => {
    var SelectedBankType = $('input[name="SelectBankType"]:checked').val();
    this.setState({ SelectedBankTypeForCreateBank: SelectedBankType, createBank: true });
  };
  fetchMcqBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/MCQList`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (!response.data.error) {
            if (response.data.listMCQ) {
              _this.setState({ mcqBankList: response.data.listMCQ });
            }
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  fetchRangeBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/RangeList`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (!response.data.error) {
            if (response.data.listRange) {
              _this.setState({ rangeBankList: response.data.listRange });
            }
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  fetchParentChildBankList = () => {
    var data = { sid: ud.main_id };
    var _this = this;
    axios
      .post(`${SERVER_IP}/bank/ParentChildList`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (!response.data.error) {
            if (response.data.listParentchild) {
              var parentChild = _this.convert(response.data.listParentchild);

              _this.setState({ listParentChild: parentChild });
            }
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  convert = (array) => {
    var map = {};
    for (var i = 0; i < array.length; i++) {
      var obj = array[i];
      obj.children = [];

      map[obj.id] = obj;

      var parent_id = obj.parent_id || "-";
      if (!map[parent_id]) {
        map[parent_id] = {
          children: [],
        };
      }
      map[parent_id].children.push(obj);
    }

    return map["-"].children;
  };
  radioMcqBankSelect = (e) => {
    this.setState({ selectedMcqBankIdForTask: e.target.value });
  };
  radioTaskLevel2 = (e) => {
    this.setState({ selectedRadioTaskLevel2: e.target.value });
  };
  radioRangeBankSelect = (e) => {
    this.setState({ selectedRangeBankIdForTask: e.target.value });
  };
  radioParentChildBankSelect = (e) => {
    this.setState({ selectedParentChildBankIdForTask: e.target.value });
  };
  addTaskFromBank = () => {
    if (this.state.selectionType === "task") {
      this.AddTaskFromBankDirectly();
    } else if (this.state.selectionType === "subtasklevel2") {
      this.AddTaskFromBankLevel2();
    }
  };

  AddTaskFromBankLevel2 = () => {
    var data;
    if (this.state.selectedBank === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 1,
        trigger_bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 2,
        trigger_bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    } else if (this.state.selectedBank === "ParentChild") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 3,
        trigger_bank_id: Number(this.state.selectedParentChildBankIdForTask),
        is_mandatory: this.state.isMandatryCheck === true ? 1 : 0,
      };
    }

    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }

    var _this = this;
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.resetAllState();
          _this.fetchTaskList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  AddTaskFromBankLevel2Banks = (optiontype, is_mandatory) => {
    var data;

    if (optiontype === "MCQ") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 1,
        trigger_bank_id: Number(this.state.selectedMcqBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else if (optiontype === "Range") {
      data = {
        sid: ud.main_id,
        workflow_id: sessionStorage.getItem("selected_workflow"),
        version_id: version_info.id,
        task_id: this.state.clicked_task_L2.task_id,
        option_type: this.state.option_type_task_L2,
        type: 2,
        trigger_bank_id: Number(this.state.selectedRangeBankIdForTask),
        is_mandatory: is_mandatory === true ? 1 : 0,
      };
    } else {
      return;
    }

    if (data == undefined) {
      return;
    } else if (data.trigger_bank_id == 0) {
      return;
    }

    var _this = this;
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.resetAllState();
          _this.fetchTaskList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  AddTaskFromBankDirectly = () => {
    var data;

    if (this.state.selectedBank === "MCQ") {
      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 1,
        bank_id: this.state.selectedMcqBankIdForTask,
        is_mandatry: this.state.isMandatryCheck,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else if (this.state.selectedBank === "Range") {
      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 2,
        bank_id: this.state.selectedRangeBankIdForTask,
        is_mandatry: this.state.isMandatryCheck,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else if (this.state.selectedBank === "ParentChild") {
      data = {
        workflow_id: sessionStorage.getItem("selected_workflow"),
        task_type: 3,
        bank_id: this.state.selectedParentChildBankIdForTask,
        is_mandatry: this.state.isMandatryCheck,
        sid: ud.main_id,
        version_id: version_info.id,
      };
    } else {
      data = {
        bank_id: "",
      };
    }

    this.setState({
      selectedMcqBankIdForTask: "",
      selectedRangeBankIdForTask: "",
      selectedParentChildBankIdForTask: "",
    });
    if (data.bank_id == "") {
      return;
    }

    var _this = this;
    axios
      .post(`${SERVER_IP}/workflowTasksExist`, data)
      .then(function (response) {
        if (response.status === 200) {
          swal(response.data.message);
          _this.resetAllState();
          _this.fetchTaskList();
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };

  isMandatryCheckbox = (e) => {
    this.setState({ isMandatryCheck: !this.state.isMandatryCheck });
  };
  isMandatryCheckboxForLevel2 = (e) => {
    this.setState({ isMandatryCheckL2: !this.state.isMandatryCheckL2 });
  };
  hideBankOption = () => {
    this.setState({ selectionType: "none" });
  };
  subTaskPlusClick = (node, option_type) => {
    // var task = this.state.allTasks.find(x => x.task_id === node.task_id);
    var temp = JSON.parse(JSON.stringify(this.state.allTasks));
    var index = this.state.allTasks.indexOf(node);

    var tasks = temp.splice(index, 1);

    this.setState({
      selectionType: "subtask",
      tasksListForTrigger: temp,
      option_type_task_L2: option_type,
      clicked_task_L2: node,
    });
  };
  SaveTaskLavel2 = () => {
    if (this.state.selectedRadioTaskLevel2 == "") {
      return;
    }
    var data = {
      sid: ud.main_id,
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
      task_id: this.state.clicked_task_L2.task_id,
      option_type: this.state.option_type_task_L2,
      type: 4,
      trigger_bank_id: Number(this.state.selectedRadioTaskLevel2),
      is_mandatory: this.state.isMandatryCheckL2 === true ? 1 : 0,
    };
    var _this = this;
    axios
      .post(`${SERVER_IP}/workFlowTasksL2`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message);
            _this.resetAllState();
            _this.fetchTaskList();
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  deleteTasks = (id, delete_type) => {
    var data = {
      id: id,
      delete_type: JSON.stringify(delete_type),
    };
    var _this = this;
    axios
      .post(`${SERVER_IP}/workflowTaskDelete`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message);
            _this.resetAllState();
            _this.fetchTaskList();
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  editTasks = (node) => {
    this.resetAllState();
    if (node.task_type == 1) {
      this.setState({
        editMode: node.task_type,
        editJson: node,
        McqTypeBankEdit: node.task[0].mcq_type,
        questionMcqEdit: node.task[0].question,
        correctMcqEdit: node.task[0].correct,
        alt1McqEdit: node.task[0].alternative_1,
        alt2McqEdit: node.task[0].alternative_2,
        alt3McqEdit: node.task[0].alternative_3,
      });
    } else if (node.task_type == 2) {
      this.setState({
        editMode: node.task_type,
        editJson: node,
        questionRangeEdit: node.task[0].question,
        maxRangeEdit: node.task[0].max_value,
        minRangeEdit: node.task[0].min_value,
      });
    }
  };
  closeEditContainer = () => {
    this.resetAllState();
    // this.fetchTaskList();
  };
  onUpdateEvent = () => {
    var data;
    if (this.state.editMode == 1) {
      data = {
        task_type: this.state.editMode,
        mcq_type: this.state.McqTypeBankEdit,
        question: this.state.questionMcqEdit,
        correct: this.state.correctMcqEdit,
        alternative_1: this.state.alt1McqEdit,
        alternative_2: this.state.alt2McqEdit,
        alternative_3: this.state.alt3McqEdit,
        id: this.state.editJson.bank_id,
      };
    } else if (this.state.editMode == 2) {
      data = {
        task_type: this.state.editMode,
        question: this.state.questionRangeEdit,
        max_value: this.state.maxRangeEdit,
        min_value: this.state.minRangeEdit,
        id: this.state.editJson.bank_id,
      };
    } else {
      return;
    }
    var _this = this;
    axios
      .post(`${SERVER_IP}/workflowEditTaskSubTask`, data)
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error === false) {
            swal(response.data.message);
            _this.resetAllState();
            _this.fetchTaskList();
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  publishClick = () => {
    this.resetAllState();
    this.setState({ publishPopup: true });
  };
  publishVersion = () => {
    var data = {
      workflow_id: sessionStorage.getItem("selected_workflow"),
      version_id: version_info.id,
      description: this.state.descriptionPublish,
    };

    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };

    var _this = this;
    axios
      .post(`${SERVER_IP}/workFlowPublish`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.status.error === false) {
            _this.resetAllState();
            _this.setState({ publishLoader: true });
            setTimeout(() => {
              this.props.history.push("/create/workflowversionlist");
            }, 4000);
          } else {
            swal(response.data.status.message);
          }
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong. Please Retry.");
      });
  };
  render() {
    const { user } = this.props;
    const { isMobile } = user;
    const { errors } = this.state;
    var TaskStructure = this.state.allTasks.map((li, index) => (
      <TaskTree
        node={li}
        children={li.children}
        index={index}
        subTaskPlusClick={this.subTaskPlusClick}
        deleteTasks={this.deleteTasks}
        editTasks={this.editTasks}
      />
    ));
    var parentChildTree =
      this.state.selectedBank === "ParentChild"
        ? this.state.listParentChild.map((li, index) => (
            <ParentChildTree
              node={li}
              children={li.children}
              index={index}
              addParentChild={this.addParentChild}
              radioParentChildBankSelect={this.radioParentChildBankSelect}
            />
          ))
        : null;
    return (
      <>
        {isMobile && (
          <HeaderMobileSearch showFilterBtn={true} backBtn={true} searchAnimated={false} searchMode={false} />
        )}

        <div class="xp-breadcrumbbar xp-heading mcqtaskrange">
          <h4 className="xp-page-title mb-3">
            <BackBtn /> Published Task
          </h4>
          <div class="row align-items-center">
            {/* <div class="col-md-6 col-lg-2">
                            <h4 class="xp-page-title"><button onClick={this.addTask} type="button" style={{ width: "180px" }} class="btn btn-primary" data-toggle="tooltip" data-placement="top" title="Add"><i class="mdi mdi-plus"></i> Add Task/ Steps</button> </h4>
                        </div> */}
            {/* <div class="col-md-12 col-lg-12"> */}
            {/* {this.state.publishStatus === "unpublish" ?
                                <h4 class="xp-page-title"><button type="button" class="btn btn-danger" style={{ width: "180px" }} data-toggle="tooltip" data-placement="top" title="Deactivate"><i class="fa fa-rocket"></i> Deactivate</button> </h4>
                                : null} */}
            {/* </div> */}
            <div class={`col-md-9 col-lg-9 ${this.state.publishStatus === "publish" ? "" : "col-lg-12"}`}>
              <div class="xp-breadcrumb gradient-border mt-0">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a onClick={() => this.props.history.push("/dashboard")}>
                      <i>
                        <HomeIcon />
                      </i>
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a onClick={() => this.props.history.push("/create/workflow")}> Workflow Management </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a onClick={() => this.props.history.push("/create/workflowversionlist")}>
                      {workflowDetails?.sopData?.sop_type_name || "Workflow type"}
                    </a>
                  </li>
                  <li class="breadcrumb-item">
                    <a> {version_info?.version || "version"} </a>
                  </li>
                </ol>
              </div>
            </div>
            <div className="col-md-3 col-lg-3">
              {this.state.publishStatus === "publish" ? (
                <h4 class="xp-page-title text-right">
                  <button
                    onClick={this.publishClick}
                    type="button"
                    class="btn btn-success"
                    style={{ width: "180px" }}
                    data-toggle="tooltip"
                    data-placement="top"
                  >
                    <i class="fa fa-rocket"></i> Publish
                  </button>
                </h4>
              ) : null}
            </div>
          </div>
        </div>
        <div class="xp-contentbar p-30 mcqtaskrange">
          <div class="row">
            <div className="col-lg-12">
              <div className="document_gradient_border mb-4 text-lef">
                <h5>
                  {JSON.parse(sessionStorage.getItem("selected_workflow_description")).title} (Version :{" "}
                  {version_info.version})
                </h5>
              </div>
            </div>
            <div class="col-lg-12">
              {this.state.publishLoader ? (
                <div className="loadingWrap">
                  <div className="loading-container">
                    <svg className="loading" viewBox="0 0 84.6 84.6">
                      <defs>
                        <filter id="stickyFilter">
                          <feGaussianBlur in="SourceGraphic" stdDeviation="2" result="blur" />
                          <feColorMatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
                            result="filter"
                          />
                          <feComposite in="SourceGraphic" in2="filter" operator="atop" />
                        </filter>
                        <linearGradient
                          id="gradient"
                          className="gradient"
                          x1="0%"
                          y1="0%"
                          x2="0%"
                          y2="40%"
                          gradientTransform="rotate(45)"
                        >
                          <stop offset="0%" />
                          <stop offset="100%" />
                        </linearGradient>
                      </defs>
                      <clipPath id="clip">
                        <circle cx="42.3" cy="42.3" r="41.6" />
                      </clipPath>
                      <g clip-path="url(#clip)">
                        <path className="background" d="M0 0h84.6v84.6H0z" />
                        <g className="exhaust">
                          <path
                            className="gradientBox"
                            d="M2.37244 65.5981l28.84968-28.84968 16.54614 16.54614-28.84968 28.84968z"
                          />
                          <path
                            className="gradientBox"
                            d="M6.35189 69.55189l28.84968-28.84968 8.34378 8.34378-28.84968 28.84968z"
                          />
                          <g className="filteredGroup">
                            <path className="line1 line lineThick" d="M47.7 49.6L13.4 83.9" />
                            <path className="line2 line lineThick" d="M42.3 42.3L8 76.6" />
                            <path className="line3 line lineThick" d="M33.5 38.5L-.8 72.8" />

                            <path className="line4 line lineDots" d="M45 45.82L10.7 80.12" />
                            <path className="line5 line lineDots" d="M38.16 40.06L3.86 74.36" />

                            <path className="line6 line lineStatic" d="M39.46 41.15L18.91 61.7" />
                            <path className="line7 line lineStatic" d="M43.57 43.77L23.02 64.32" />
                          </g>
                        </g>
                        <g className="rotate">
                          <g className="rumble">
                            <path
                              className="arrow"
                              d="M60.8 27.2c.6-2.1-1.3-4-3.4-3.4L19.5 35.3c-2.2.7-2.6 3.6-.8 4.9l15.8 7.6c1.1.5 2 1.4 2.5 2.6L44.4 66c1.3 1.9 4.2 1.4 4.9-.8l11.5-38z"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                    <div className="label anime-text">Publish your request...</div>
                  </div>
                </div>
              ) : null}
              <div id="sortable">
                {TaskStructure}
                {this.state.allTasks.length === 0 ? (
                  this.state.message === "" ? (
                    // loader
                    <div className="lds-spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  ) : (
                    // loader-end
                    <div className="message-no-record"> {this.state.message} </div>
                  )
                ) : null}
                {this.state.publishPopup ? (
                  <div id="popup" class="overlay">
                    <div class="popup" style={{ width: "60%", margin: "10% auto" }}>
                      <div class="content">
                        <div className="card m-b-30">
                          <div className="card-header bg-white heading-cont">
                            <h5 className="card-title text-black">Publish Version</h5>
                            <div onClick={() => this.setState({ publishPopup: false })}>
                              <svg
                                class="bi bi-x-circle-fill"
                                width="1em"
                                height="1em"
                                viewBox="0 0 16 16"
                                fill="currentColor"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                  clip-rule="evenodd"
                                />
                              </svg>
                            </div>
                          </div>

                          <div className="card-body ">
                            <div className="form-group">
                              <p className="cus-badge">
                                Version : <span>{version_info.version}</span>
                              </p>
                            </div>
                            <div className="form-group">
                              <label for="exampleInputEmail1">Description</label>
                              <input
                                type="text"
                                onChange={this.onChangeInput}
                                name="descriptionPublish"
                                className="form-control"
                                placeholder="Enter Version"
                              />
                            </div>
                            <button onClick={this.publishVersion} className="btn btn-primary mt-3">
                              Publish
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}

                <div class="side-drag-wrapper dragme" draggable="true" data-item="0">
                  {this.state.selectionType != "none" ? (
                    <div>
                      {this.state.selectionType == "task" || this.state.selectionType == "subtasklevel2" ? (
                        <div class="card border-secondary">
                          <div class="card-header bg-dark pr-2 pl-3" id="headingOne">
                            <div class="dv-center w-100 justify-content-between">
                              <h4 class="text-white">Library</h4>
                              <div>
                                <button
                                  class="btn btn-round btn-primary mr-2"
                                  type="button"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Drag Anywhere"
                                >
                                  <i class="dripicons-move text-white"></i>
                                </button>

                                <button
                                  onClick={this.hideBankOption}
                                  type="button"
                                  class="close-s"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Close"
                                >
                                  <svg
                                    fill="#fff"
                                    focusable="false"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                  >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                            <div class="mt-2 d-flex justify-content-center lib-btn">
                              <div className="item">
                                <div class="custom-control custom-radio custom-control-inline" title="MCQ">
                                  <input
                                    type="radio"
                                    value="MCQ"
                                    id="customRadioInline1"
                                    name="SelectBankType"
                                    onChange={this.selectedBank}
                                    class="custom-control-input"
                                  />
                                  <label class="custom-control-label" for="customRadioInline1">
                                    MCQ
                                  </label>
                                </div>
                              </div>
                              <div className="item">
                                <div class="custom-control custom-radio custom-control-inline" title="Range">
                                  <input
                                    type="radio"
                                    value="Range"
                                    id="customRadioInline2"
                                    name="SelectBankType"
                                    onChange={this.selectedBank}
                                    class="custom-control-input"
                                  />
                                  <label class="custom-control-label" for="customRadioInline2">
                                    Range
                                  </label>
                                </div>
                              </div>
                              <div className="item">
                                <div class="custom-control custom-radio custom-control-inline" title="Parent Child">
                                  <input
                                    type="radio"
                                    value="ParentChild"
                                    id="customRadioInline3"
                                    name="SelectBankType"
                                    onChange={this.selectedBank}
                                    class="custom-control-input"
                                  />
                                  <label class="custom-control-label" for="customRadioInline3">
                                    Parent Child
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div id="dragwrapper" class="collapse show" aria-labelledby="headingOne">
                            {this.state.createBank && this.state.SelectedBankTypeForCreateBank != undefined ? (
                              <div>
                                {this.state.SelectedBankTypeForCreateBank === "MCQ" ? (
                                  <div>
                                    <div className="card-header bg-white heading-cont">
                                      <h5 className="card-title text-black">Create MCQ Bank</h5>
                                      <div onClick={() => this.setState({ createBank: false })}>
                                        <svg
                                          class="bi bi-x-circle-fill"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 16 16"
                                          fill="currentColor"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                            clip-rule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </div>

                                    <div class="card-body">
                                      <div class="form-row">
                                        <div className="form-group col-md-6">
                                          <h4>MCQ Type</h4>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                          <input
                                            type="radio"
                                            value="mcq"
                                            id="customRadioInline4"
                                            name="SelectMcqType"
                                            onChange={this.selectedMcqType}
                                            class="custom-control-input"
                                          />
                                          <label class="custom-control-label" for="customRadioInline4">
                                            MCQ
                                          </label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline">
                                          <input
                                            type="radio"
                                            value="yesno"
                                            id="customRadioInline5"
                                            name="SelectMcqType"
                                            onChange={this.selectedMcqType}
                                            class="custom-control-input"
                                          />
                                          <label class="custom-control-label" for="customRadioInline5">
                                            Yes/No
                                          </label>
                                        </div>
                                      </div>
                                      <div className="form-group">
                                        <label for="exampleInputEmail1">Question</label>
                                        <input
                                          type="text"
                                          onChange={this.onChangeInput}
                                          name="quectionMcq"
                                          className="form-control"
                                          placeholder="Enter Question"
                                        />
                                      </div>

                                      {this.state.McqTypeBank === "mcq" ? (
                                        <div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Correct Answer</label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="correctAnsMcq"
                                              value={this.state.correctAnsMcq}
                                              className="form-control"
                                              placeholder="Enter Correct Answer"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Alternative 1</label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="alt1AnsMcq"
                                              value={this.state.alt1AnsMcq}
                                              className="form-control"
                                              placeholder="Enter Alternative 1 Answer"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Alternative 2</label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="alt2AnsMcq"
                                              value={this.state.alt2AnsMcq}
                                              className="form-control"
                                              placeholder="Enter Alternative 2 Answer"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Alternative 3</label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="alt3AnsMcq"
                                              value={this.state.alt3AnsMcq}
                                              className="form-control"
                                              placeholder="Enter Alternative 3 Answer"
                                            />
                                          </div>
                                          <div class="form-row">
                                            <div className="form-group col-md-2">
                                              <input
                                                type="checkbox"
                                                name="mcqIsMandatry"
                                                onChange={this.handleCheckbox}
                                                checked={this.state.mcqIsMandatry}
                                              />
                                            </div>
                                            <div className="form-group col-md-6">Is Mandatry</div>
                                          </div>
                                          <button
                                            onClick={this.SaveMcqBank}
                                            type="button"
                                            class="btn btn-primary"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Add"
                                          >
                                            Save
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}

                                      {this.state.McqTypeBank === "yesno" ? (
                                        <div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Correct Answer</label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="correctAnsMcq"
                                              value={this.state.correctAnsMcq}
                                              className="form-control"
                                              placeholder="Enter Correct Answer"
                                            />
                                          </div>
                                          <div className="form-group">
                                            <label for="exampleInputEmail1">Alternative </label>
                                            <input
                                              type="text"
                                              onChange={this.onChangeInput}
                                              name="alt1AnsMcq"
                                              value={this.state.alt1AnsMcq}
                                              className="form-control"
                                              placeholder="Enter Alternative 1 Answer"
                                            />
                                          </div>
                                          <div class="form-row">
                                            <div className="form-group col-md-2">
                                              <input
                                                type="checkbox"
                                                name="mcqIsMandatry"
                                                onChange={this.handleCheckbox}
                                                checked={this.state.mcqIsMandatry}
                                              />
                                            </div>
                                            <div className="form-group col-md-6">Is Mandatry</div>
                                          </div>

                                          <button
                                            onClick={this.SaveMcqBank}
                                            type="button"
                                            class="btn btn-primary"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="Add"
                                          >
                                            Save
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {this.state.SelectedBankTypeForCreateBank === "Range" ? (
                                  <div>
                                    <div className="card-header bg-white heading-cont">
                                      <h5 className="card-title text-black">Create Range Bank</h5>
                                      <div onClick={() => this.setState({ createBank: false })}>
                                        <svg
                                          class="bi bi-x-circle-fill"
                                          width="1em"
                                          height="1em"
                                          viewBox="0 0 16 16"
                                          fill="currentColor"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            fill-rule="evenodd"
                                            d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                            clip-rule="evenodd"
                                          />
                                        </svg>
                                      </div>
                                    </div>

                                    <div class="card-body">
                                      <div className="form-group">
                                        <label for="exampleInputEmail1">Question</label>
                                        <input
                                          type="text"
                                          onChange={this.onChangeInput}
                                          name="quectionRange"
                                          className="form-control"
                                          placeholder="Enter Question"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label for="exampleInputEmail1">Minimum Value</label>
                                        <input
                                          type="number"
                                          onChange={this.onChangeInput}
                                          name="minRange"
                                          className="form-control"
                                          placeholder="Enter Minimum Value"
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label for="exampleInputEmail1">Maximum Value</label>
                                        <input
                                          type="number"
                                          onChange={this.onChangeInput}
                                          name="maxRange"
                                          className="form-control"
                                          placeholder="Enter Maximum Value"
                                        />
                                      </div>
                                      <div class="form-row">
                                        <div className="form-group col-md-2">
                                          <input
                                            type="checkbox"
                                            name="rangeIsMandatry"
                                            onChange={this.handleCheckbox}
                                            checked={this.state.rangeIsMandatry}
                                          />
                                        </div>
                                        <div className="form-group col-md-6">Is Mandatry</div>
                                      </div>

                                      <button
                                        onClick={this.SaveRangeBank}
                                        type="button"
                                        class="btn btn-primary"
                                        data-toggle="tooltip"
                                        data-placement="top"
                                        title="Add"
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                {this.state.SelectedBankTypeForCreateBank === "ParentChild" ? (
                                  <div>
                                    <div class="questionnaire">
                                      <div class="card-header bg-dark pr-2 pl-3 dv-center">
                                        <div class="mt-2">
                                          <h4 class="text-white">Create Parent</h4>
                                          <div class="custom-control custom-radio custom-control-inline"></div>
                                        </div>
                                      </div>
                                      <button
                                        onClick={() => this.setState({ createBank: false, question_pc_bank: "" })}
                                        type="button"
                                        class="btn btn-round btn-danger close-q"
                                      >
                                        <i class="mdi mdi-close"></i>
                                      </button>

                                      <div class="stp1">
                                        <div class="form-content text-center">
                                          <input
                                            type="text"
                                            onChange={this.onChangeInput}
                                            class="form-control"
                                            name="question_pc_bank"
                                            id="inputText"
                                            placeholder="Question..."
                                          />
                                          <button
                                            onClick={this.saveParentChildBankForP}
                                            type="button"
                                            class="btn btn-primary mt-3"
                                          >
                                            <i class="mdi mdi-plus mr-2"></i> Add
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              <div class="card-body pos-rel">
                                <div class="stick-up">
                                  <div className="filter-form">
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="inputText"
                                      id="inputText"
                                      placeholder="Filter Search"
                                    />
                                    <input
                                      type="text"
                                      class="form-control"
                                      name="inputText"
                                      id="inputText"
                                      placeholder="Filter Search"
                                    />
                                    <select className="form-control">
                                      <option>Item</option>
                                      <option>Item</option>
                                      <option>Item</option>
                                      <option>Item</option>
                                      <option>Item</option>
                                    </select>
                                  </div>
                                  <div className="pull-right mt-2">
                                    <button type="button" onClick={this.createBank} class="btn btn-primary ml-2">
                                      <i class="mdi mdi-plus"></i> Create
                                    </button>

                                    <button type="button" onClick={this.addTaskFromBank} class="btn btn-primary ml-2">
                                      <i class="mdi mdi-plus"></i> Add Task
                                    </button>
                                  </div>
                                  <div className="clearfix"></div>
                                </div>
                                <div class="form-row mt-3">
                                  <div className="form-group ismandtry">
                                    <input id="c1" type="checkbox" onChange={this.isMandatryCheckbox} />
                                    <label className="mb-0" for="c1">
                                      &nbsp; Is Mandatry
                                    </label>
                                  </div>
                                </div>
                                {this.state.selectedBank === "MCQ" ? (
                                  <div class="mt-2 sticky-fixed">
                                    {this.state.mcqBankList.map((list, index) => (
                                      <div className="item">
                                        <div class="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id={`customRadio${index + 10}`}
                                            value={list.id}
                                            onChange={this.radioMcqBankSelect}
                                            name="mcqBankRadio"
                                            class="custom-control-input"
                                          />
                                          <label class="custom-control-label" for={`customRadio${index + 10}`}>
                                            {list.question}
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : null}
                                {this.state.selectedBank === "Range" ? (
                                  <div class="mt-2 sticky-fixed">
                                    {this.state.rangeBankList.map((list, index) => (
                                      <div className="item">
                                        <div class="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id={`customRadio${index + 10}`}
                                            value={list.id}
                                            onChange={this.radioRangeBankSelect}
                                            name="rangeBankRadio"
                                            class="custom-control-input"
                                          />
                                          <label class="custom-control-label" for={`customRadio${index + 10}`}>
                                            {list.question}
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ) : null}
                                {this.state.selectedBank === "ParentChild" ? (
                                  <div class="mt-2 sticky-fixed" style={{ height: "290px" }}>
                                    {parentChildTree}
                                    {this.state.selectedNodeIDForPC ? (
                                      <div>
                                        <div class="questionnaire">
                                          <div class="card-header bg-dark pr-2 pl-3 dv-center">
                                            <div class="mt-2">
                                              <h4 class="text-white">Create Parent</h4>
                                              <div class="custom-control custom-radio custom-control-inline">
                                                <input
                                                  type="radio"
                                                  id="in-1"
                                                  value="1"
                                                  onChange={this.onChangeInputCreateParent}
                                                  name="p_c_question_type"
                                                  class="custom-control-input"
                                                />
                                                <label class="custom-control-label" for="in-1">
                                                  MCQ
                                                </label>
                                              </div>
                                              <div class="custom-control custom-radio custom-control-inline">
                                                <input
                                                  type="radio"
                                                  id="in-2"
                                                  value="2"
                                                  onChange={this.onChangeInputCreateParent}
                                                  name="p_c_question_type"
                                                  class="custom-control-input"
                                                />
                                                <label class="custom-control-label" for="in-2">
                                                  Range
                                                </label>
                                              </div>
                                              <div class="custom-control custom-radio custom-control-inline">
                                                <input
                                                  type="radio"
                                                  id="in-3"
                                                  value="3"
                                                  onChange={this.onChangeInputCreateParent}
                                                  name="p_c_question_type"
                                                  class="custom-control-input"
                                                />
                                                <label class="custom-control-label" for="in-3">
                                                  Parent Child
                                                </label>
                                              </div>
                                            </div>
                                          </div>

                                          <button
                                            onClick={() =>
                                              this.setState({
                                                selectedRangeBankIdForTask: "",
                                                selectedMcqBankIdForTask: "",
                                                p_c_question_type: null,
                                                selectedNodeIDForPC: undefined,
                                              })
                                            }
                                            type="button"
                                            class="btn btn-round btn-danger close-q"
                                          >
                                            <i class="mdi mdi-close"></i>
                                          </button>

                                          <div class="stp1">
                                            {this.state.p_c_question_type == 1 ? (
                                              <div>
                                                {this.state.createBankMcqOnP_C ? (
                                                  <div class="mt-2 align-ab parent-list-cont">
                                                    <div className="card-header bg-white heading-cont">
                                                      <h5 className="card-title text-black">Create MCQ Bank</h5>
                                                      <div
                                                        onClick={() =>
                                                          this.setState({
                                                            createBankMcqOnP_C: false,
                                                            quectionMcq: "",
                                                            correctAnsMcq: "",
                                                            alt1AnsMcq: "",
                                                            alt2AnsMcq: "",
                                                            alt3AnsMcq: "",
                                                            mcqIsMandatry: false,
                                                            McqTypeBank: "",
                                                          })
                                                        }
                                                      >
                                                        <svg
                                                          class="bi bi-x-circle-fill"
                                                          width="1em"
                                                          height="1em"
                                                          viewBox="0 0 16 16"
                                                          fill="currentColor"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fill-rule="evenodd"
                                                            d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                                            clip-rule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>

                                                    <div class="card-body">
                                                      <div class="form-row">
                                                        <div className="form-group col-md-6">
                                                          <h4>MCQ Type</h4>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                          <input
                                                            type="radio"
                                                            value="mcq"
                                                            id="customRadioInline4"
                                                            name="SelectMcqType"
                                                            onChange={this.selectedMcqType}
                                                            class="custom-control-input"
                                                          />
                                                          <label class="custom-control-label" for="customRadioInline4">
                                                            MCQ
                                                          </label>
                                                        </div>
                                                        <div class="custom-control custom-radio custom-control-inline">
                                                          <input
                                                            type="radio"
                                                            value="yesno"
                                                            id="customRadioInline5"
                                                            name="SelectMcqType"
                                                            onChange={this.selectedMcqType}
                                                            class="custom-control-input"
                                                          />
                                                          <label class="custom-control-label" for="customRadioInline5">
                                                            Yes/No
                                                          </label>
                                                        </div>
                                                      </div>
                                                      <div className="form-group">
                                                        <label for="exampleInputEmail1">Question</label>
                                                        <input
                                                          type="text"
                                                          onChange={this.onChangeInput}
                                                          name="quectionMcq"
                                                          className="form-control"
                                                          placeholder="Enter Question"
                                                        />
                                                      </div>

                                                      {this.state.McqTypeBank === "mcq" ? (
                                                        <div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Correct Answer</label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="correctAnsMcq"
                                                              value={this.state.correctAnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Correct Answer"
                                                            />
                                                          </div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Alternative 1</label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="alt1AnsMcq"
                                                              value={this.state.alt1AnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Alternative 1 Answer"
                                                            />
                                                          </div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Alternative 2</label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="alt2AnsMcq"
                                                              value={this.state.alt2AnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Alternative 2 Answer"
                                                            />
                                                          </div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Alternative 3</label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="alt3AnsMcq"
                                                              value={this.state.alt3AnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Alternative 3 Answer"
                                                            />
                                                          </div>
                                                          <div class="form-row">
                                                            <div className="form-group col-md-2">
                                                              <input
                                                                type="checkbox"
                                                                name="mcqIsMandatry"
                                                                onChange={this.handleCheckbox}
                                                                checked={this.state.mcqIsMandatry}
                                                              />
                                                            </div>
                                                            <div className="form-group col-md-6">Is Mandatry</div>
                                                          </div>
                                                          <button
                                                            onClick={this.saveMcqBankDataOnPC}
                                                            type="button"
                                                            class="btn btn-primary save-btn"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Add"
                                                          >
                                                            Save
                                                          </button>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}

                                                      {this.state.McqTypeBank === "yesno" ? (
                                                        <div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Correct Answer</label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="correctAnsMcq"
                                                              value={this.state.correctAnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Correct Answer"
                                                            />
                                                          </div>
                                                          <div className="form-group">
                                                            <label for="exampleInputEmail1">Alternative </label>
                                                            <input
                                                              type="text"
                                                              onChange={this.onChangeInput}
                                                              name="alt1AnsMcq"
                                                              value={this.state.alt1AnsMcq}
                                                              className="form-control"
                                                              placeholder="Enter Alternative 1 Answer"
                                                            />
                                                          </div>
                                                          <div class="form-row">
                                                            <div className="form-group col-md-2">
                                                              <input
                                                                type="checkbox"
                                                                name="mcqIsMandatry"
                                                                onChange={this.handleCheckbox}
                                                                checked={this.state.mcqIsMandatry}
                                                              />
                                                            </div>
                                                            <div className="form-group col-md-6">Is Mandatry</div>
                                                          </div>

                                                          <button
                                                            onClick={this.saveMcqBankDataOnPC}
                                                            class="btn btn-primary save-btn"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Add"
                                                          >
                                                            Save
                                                          </button>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div class="mt-2 parent-list-wrapper">
                                                    <div className="parent-list-cont">
                                                      {this.state.mcqBankList.map((list, index) => (
                                                        <div class="custom-control custom-radio">
                                                          <input
                                                            type="radio"
                                                            id={`customRadio${index + 10}`}
                                                            value={list.id}
                                                            onChange={this.radioMcqBankSelect}
                                                            name="mcqBankRadio"
                                                            class="custom-control-input"
                                                          />
                                                          <label
                                                            class="custom-control-label"
                                                            for={`customRadio${index + 10}`}
                                                          >
                                                            {list.question}
                                                          </label>
                                                        </div>
                                                      ))}
                                                    </div>
                                                    <div className="bt-btn dv-center">
                                                      <button
                                                        onClick={() => this.saveParentChildBankForC(1)}
                                                        type="button"
                                                        class="btn btn-primary mr-2"
                                                      >
                                                        <i class="mdi mdi-plus mr-2"></i> Add
                                                      </button>
                                                      <button
                                                        onClick={() => this.setState({ createBankMcqOnP_C: true })}
                                                        type="button"
                                                        class="btn btn-primary mr-2"
                                                      >
                                                        <i class="mdi mdi-plus mr-2"></i> Create
                                                      </button>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ) : null}
                                            {this.state.p_c_question_type == 2 ? (
                                              <div>
                                                {this.state.createBankRangeOnP_C ? (
                                                  <div className="parent-list-cont mt-2 align-ab">
                                                    <div className="card-header bg-white heading-cont">
                                                      <h5 className="card-title text-black">Create Range Bank</h5>
                                                      <div
                                                        onClick={() =>
                                                          this.setState({
                                                            createBankRangeOnP_C: false,
                                                            quectionRange: "",
                                                            max_value: "",
                                                            min_value: "",
                                                            is_mandatory: "",
                                                          })
                                                        }
                                                      >
                                                        <svg
                                                          class="bi bi-x-circle-fill"
                                                          width="1em"
                                                          height="1em"
                                                          viewBox="0 0 16 16"
                                                          fill="currentColor"
                                                          xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                          <path
                                                            fill-rule="evenodd"
                                                            d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-4.146-3.146a.5.5 0 00-.708-.708L8 7.293 4.854 4.146a.5.5 0 10-.708.708L7.293 8l-3.147 3.146a.5.5 0 00.708.708L8 8.707l3.146 3.147a.5.5 0 00.708-.708L8.707 8l3.147-3.146z"
                                                            clip-rule="evenodd"
                                                          />
                                                        </svg>
                                                      </div>
                                                    </div>

                                                    <div class="card-body">
                                                      <div className="form-group">
                                                        <label for="exampleInputEmail1">Question</label>
                                                        <input
                                                          type="text"
                                                          onChange={this.onChangeInput}
                                                          name="quectionRange"
                                                          className="form-control"
                                                          placeholder="Enter Question"
                                                        />
                                                      </div>
                                                      <div className="form-group">
                                                        <label for="exampleInputEmail1">Minimum Value</label>
                                                        <input
                                                          type="number"
                                                          onChange={this.onChangeInput}
                                                          name="minRange"
                                                          className="form-control"
                                                          placeholder="Enter Minimum Value"
                                                        />
                                                      </div>
                                                      <div className="form-group">
                                                        <label for="exampleInputEmail1">Maximum Value</label>
                                                        <input
                                                          type="number"
                                                          onChange={this.onChangeInput}
                                                          name="maxRange"
                                                          className="form-control"
                                                          placeholder="Enter Maximum Value"
                                                        />
                                                      </div>
                                                      <div class="form-row">
                                                        <div className="form-group col-md-2">
                                                          <input
                                                            type="checkbox"
                                                            name="rangeIsMandatry"
                                                            onChange={this.handleCheckbox}
                                                            checked={this.state.rangeIsMandatry}
                                                          />
                                                        </div>
                                                        <div className="form-group col-md-6">Is Mandatry</div>
                                                      </div>

                                                      <button
                                                        onClick={this.saveRangeBankDataOnPC}
                                                        type="button"
                                                        class="btn btn-primary save-btn"
                                                        data-toggle="tooltip"
                                                        data-placement="top"
                                                        title="Add"
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div class="mt-2 parent-list-wrapper">
                                                    <div className="parent-list-cont">
                                                      {this.state.rangeBankList.map((list, index) => (
                                                        <div class="custom-control custom-radio">
                                                          <input
                                                            type="radio"
                                                            id={`customRadio${index + 10}`}
                                                            value={list.id}
                                                            onChange={this.radioRangeBankSelect}
                                                            name="rangeBankRadio"
                                                            class="custom-control-input"
                                                          />
                                                          <label
                                                            class="custom-control-label"
                                                            for={`customRadio${index + 10}`}
                                                          >
                                                            {list.question}
                                                          </label>
                                                        </div>
                                                      ))}
                                                    </div>
                                                    <div className="bt-btn dv-center">
                                                      <button
                                                        onClick={() => this.saveParentChildBankForC(2)}
                                                        type="button"
                                                        class="btn btn-primary mt-3 btn-1"
                                                      >
                                                        <i class="mdi mdi-plus mr-2 "></i> Add
                                                      </button>
                                                      <button
                                                        onClick={() => this.setState({ createBankRangeOnP_C: true })}
                                                        type="button"
                                                        class="btn btn-primary float-right mt-3 btn-2"
                                                      >
                                                        <i class="mdi mdi-plus mr-2"></i> Create
                                                      </button>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ) : null}
                                            {this.state.p_c_question_type == 3 ? (
                                              <div class="form-content text-center">
                                                <input
                                                  type="text"
                                                  onChange={this.onChangeInput}
                                                  class="form-control"
                                                  name="question_pc_bank"
                                                  id="inputText"
                                                  placeholder="Question..."
                                                />
                                                <button
                                                  onClick={() => this.saveParentChildBankForC(3)}
                                                  type="button"
                                                  class="btn btn-primary mt-3"
                                                >
                                                  <i class="mdi mdi-plus mr-2"></i> Add
                                                </button>
                                              </div>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>
                      ) : null}
                      {this.state.selectionType == "subtask" ? (
                        <div class="card border-secondary">
                          <div className="subtask-cont">
                            {this.state.subtask_type == "none" ? (
                              <div class="questionnaire">
                                <div className="t-header bg-dark">
                                  <h2 className="text-light">Library </h2>
                                  {/* <p className="text-light">gukjbjbkjvkjvkjvkjb</p> */}
                                </div>
                                <button
                                  onClick={() => this.setState({ selectionType: "none", subtask_type: "none" })}
                                  type="button"
                                  class="btn btn-round btn-danger close-q"
                                >
                                  <i class="mdi mdi-close"></i>
                                </button>
                                <div class="stp1">
                                  <div class="mt-2">
                                    <button
                                      class="btn btn-primary mt-3"
                                      onClick={() => this.setState({ subtask_type: "next" })}
                                    >
                                      Proceed To Next Task
                                    </button>
                                    <button
                                      class="btn btn-primary mt-3 ml-2"
                                      onClick={() =>
                                        this.setState({ subtask_type: "none", selectionType: "subtasklevel2" })
                                      }
                                    >
                                      Sub Task
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : null}
                            {this.state.subtask_type == "next" ? (
                              <div class="questionnaire">
                                <div className="t-header bg-dark">
                                  <h2 className="text-light">Library </h2>
                                  {/* <p className="text-light">gukjbjbkjvkjvkjvkjb</p> */}
                                </div>
                                <button
                                  onClick={() => this.setState({ selectionType: "none", subtask_type: "none" })}
                                  type="button"
                                  class="btn btn-round btn-danger close-q"
                                >
                                  <i class="mdi mdi-close"></i>
                                </button>
                                <div class="t_height">
                                  <div class="mt-2 sticky-fixed">
                                    {this.state.tasksListForTrigger.map((list, index) => (
                                      <div className="item">
                                        <div class="custom-control custom-radio">
                                          <input
                                            type="radio"
                                            id={`customRadiobtn${index + 10}`}
                                            value={list.task_id}
                                            onChange={this.radioTaskLevel2}
                                            name="mcqBankRadio"
                                            class="custom-control-input"
                                          />
                                          <label class="custom-control-label" for={`customRadiobtn${index + 10}`}>
                                            {list.task[0].question}
                                          </label>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                </div>

                                <div class="b-foot">
                                  <div>
                                    <input
                                      id="check2"
                                      type="checkbox"
                                      checked={this.state.isMandatryCheckL2}
                                      onChange={this.isMandatryCheckboxForLevel2}
                                    />
                                    <label for="check2" className="ml-2">
                                      Is Mandatry
                                    </label>
                                  </div>
                                  <button class="btn btn-primary mt-3" onClick={this.SaveTaskLavel2}>
                                    Done
                                  </button>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  {this.state.editMode == 1 ? (
                    <div class="card border-secondary">
                      <div class="card border-secondary">
                        <div
                          class="dv-center justify-content-between card-header bg-dark pr-2 pl-3 dv-center"
                          id="headingOne"
                        >
                          <div class="mt-2 top-cont-edit">
                            <h4 class="text-white">Update</h4>
                          </div>
                          <button
                            onClick={this.closeEditContainer}
                            type="button"
                            class="close-s"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Close"
                          >
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <div class="form-row">
                        <div className="form-group col-md-6">
                          <h4>MCQ Type</h4>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            value="1"
                            id="customRadioInline4"
                            name="SelectMcqType"
                            onChange={this.selectedEdit}
                            class="custom-control-input"
                            checked={this.state.McqTypeBankEdit == 1 ? true : false}
                          />
                          <label class="custom-control-label" for="customRadioInline4">
                            MCQ
                          </label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                          <input
                            type="radio"
                            value="2"
                            id="customRadioInline5"
                            name="SelectMcqType"
                            onChange={this.selectedEdit}
                            class="custom-control-input"
                            checked={this.state.McqTypeBankEdit == 2 ? true : false}
                          />
                          <label class="custom-control-label" for="customRadioInline5">
                            Yes/No
                          </label>
                        </div>
                      </div>
                      <div class="card-body">
                        <div className="form-group">
                          <label for="exampleInputEmail1">Question</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="questionMcqEdit"
                            value={this.state.questionMcqEdit}
                            className="form-control"
                            placeholder="Enter Correct Answer"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputEmail1">Correct Answer</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="correctMcqEdit"
                            value={this.state.correctMcqEdit}
                            className="form-control"
                            placeholder="Enter Correct Answer"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputEmail1">Alternative 1</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="alt1McqEdit"
                            value={this.state.alt1McqEdit}
                            className="form-control"
                            placeholder="Enter Alternative 1 Answer"
                          />
                        </div>
                        {this.state.McqTypeBankEdit == 2 ? null : (
                          <div className="form-group">
                            <label for="exampleInputEmail1">Alternative 2</label>
                            <input
                              type="text"
                              onChange={this.onChangeInput}
                              name="alt2McqEdit"
                              value={this.state.alt2McqEdit}
                              className="form-control"
                              placeholder="Enter Alternative 2 Answer"
                            />
                          </div>
                        )}
                        {this.state.McqTypeBankEdit == 2 ? null : (
                          <div className="form-group">
                            <label for="exampleInputEmail1">Alternative 3</label>
                            <input
                              type="text"
                              onChange={this.onChangeInput}
                              name="alt3McqEdit"
                              value={this.state.alt3McqEdit}
                              className="form-control"
                              placeholder="Enter Alternative 3 Answer"
                            />
                          </div>
                        )}
                        <button type="button" onClick={this.onUpdateEvent} class="btn btn-primary ml-2">
                          Update
                        </button>
                      </div>
                    </div>
                  ) : null}
                  {this.state.editMode == 2 ? (
                    <div class="card border-secondary">
                      <div class="card border-secondary">
                        <div class="card-header bg-dark pr-2 pl-3 dv-center justify-content-between" id="headingOne">
                          <div class="mt-2 top-cont-edit">
                            <h4 class="text-white">Update</h4>
                          </div>
                          <button
                            onClick={this.closeEditContainer}
                            type="button"
                            class="close-s"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Close"
                          >
                            <svg fill="#fff" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>

                      <div class="card-body">
                        <div className="form-group">
                          <label for="exampleInputEmail1">Question</label>
                          <input
                            type="text"
                            onChange={this.onChangeInput}
                            name="questionRangeEdit"
                            value={this.state.questionRangeEdit}
                            className="form-control"
                            placeholder="Enter Correct Answer"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputEmail1">Minimum Value</label>
                          <input
                            type="number"
                            onChange={this.onChangeInput}
                            name="minRangeEdit"
                            value={this.state.minRangeEdit}
                            className="form-control"
                            placeholder="Enter Minimum Value"
                          />
                        </div>
                        <div className="form-group">
                          <label for="exampleInputEmail1">Maximum Value</label>
                          <input
                            type="number"
                            onChange={this.onChangeInput}
                            name="maxRangeEdit"
                            value={this.state.maxRangeEdit}
                            className="form-control"
                            placeholder="Enter Alternative 1 Answer"
                          />
                        </div>

                        <button type="button" onClick={this.onUpdateEvent} class="btn btn-primary ml-2">
                          Update
                        </button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
// export default CreateTaskBank

class TaskTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmPopUp: false,
      isToggleOn: true,
      isToggle2On: true,
      isToggle3On: true,
      isToggle4On: true,
      isToggle5On: true,
      isToggle6On: true,
      isToggle7On: true,
      isToggle8On: true,
      isToggle9On: true,
    };
  }

  toggleHandler = () => {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  };

  toggleHandler2 = () => {
    this.setState((state) => ({
      isToggle2On: !state.isToggle2On,
    }));
  };

  toggleHandler3 = () => {
    this.setState((state) => ({
      isToggle3On: !state.isToggle3On,
    }));
  };

  toggleHandler4 = () => {
    this.setState((state) => ({
      isToggle4On: !state.isToggle4On,
    }));
  };

  toggleHandler5 = () => {
    this.setState((state) => ({
      isToggle5On: !state.isToggle5On,
    }));
  };

  toggleHandler6 = () => {
    this.setState((state) => ({
      isToggle6On: !state.isToggle6On,
    }));
  };

  toggleHandler7 = () => {
    this.setState((state) => ({
      isToggle7On: !state.isToggle7On,
    }));
  };

  toggleHandler8 = () => {
    this.setState((state) => ({
      isToggle8On: !state.isToggle8On,
    }));
  };

  toggleHandler9 = () => {
    this.setState((state) => ({
      isToggle9On: !state.isToggle9On,
    }));
  };

  selectedNodeToDelete = (node, delete_type) => {
    this.setState({
      confirmPopUp: true,
      delete_type: delete_type,
      selectedIdForDelete: node.task_id,
      selectedQue: node.task[0].question,
    });
  };
  deleteSubTasks = (node, delete_type) => {
    this.setState({
      confirmPopUp: true,
      delete_type: delete_type,
      selectedIdForDelete: node.subTask_id,
      selectedQue: node.task[0].question,
    });
  };
  deleteTasksTypeFour = (node, delete_type) => {
    this.setState({ confirmPopUp: true, delete_type: delete_type, selectedIdForDelete: node.task_id, selectedQue: "" });
  };
  deleteTasks = () => {
    this.setState({ confirmPopUp: false });
    this.props.deleteTasks(this.state.selectedIdForDelete, this.state.delete_type);
  };

  render() {
    // var node = this.props.children ? this.props.children.map((li, index) => <TaskTree node={li} subTaskPlusClick={this.props.subTaskPlusClick} children={li.children} index={index} />) : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    return (
      <div className="ui-state-default ui-st1">
        {this.state.confirmPopUp ? (
          <div class="cd-popup is-visible" role="alert">
            <div class="cd-popup-container">
              <h5>Are you sure you want to delete this task?</h5>
              <h4 className="child-p">{this.state.selectedQue}</h4>
              <ul class="cd-buttons">
                <li>
                  <a onClick={this.deleteTasks}>Yes</a>
                </li>
                <li onClick={() => this.setState({ confirmPopUp: false })}>
                  <a>No</a>
                </li>
              </ul>
              <a onClick={() => this.setState({ confirmPopUp: false })} class="cd-popup-close img-replace">
                Close
              </a>
            </div>
          </div>
        ) : null}

        <div class="accordion" id="accordion_task">
          <div class="card mb-2">
            <div>
              <div class="card-header p-1" id={`headingOne${randomno}`}>
                <div class="mb-0 dv-center space-between">
                  <div class="dv-center">
                    <button
                      onClick={this.toggleHandler}
                      class="btn btn-link arrow-s"
                      type="button"
                      data-toggle="collapse"
                      data-target={`#collapseOne${randomno}`}
                      aria-expanded="true"
                      aria-controls={`#collapseOne${randomno}`}
                    >
                      <i className={this.state.isToggleOn ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                    </button>

                    <h6 class="mb-0">
                      <span className="mr-2">
                        {this.props.node.task_type == 1 ? <i class="fa fa-th-list"></i> : null}
                        {this.props.node.task_type == 2 ? <i class="fa fa-sort-numeric-asc"></i> : null}
                        {this.props.node.task_type == 3 ? <i class="fa fa-sitemap"></i> : null}
                      </span>
                      {this.props.index + 1} : {this.props.node.task[0].question}
                    </h6>
                  </div>
                  {this.props.node.is_mandatory ? (
                    <a class="badge badge-success text-white mr-2">Compulsory</a>
                  ) : (
                    <a class="badge badge-danger text-white mr-2">Non-Compulsory</a>
                  )}

                  {/* <div >
                                        {this.props.node.task_type == 3 ? null :
                                            <button onClick={() => this.props.editTasks(this.props.node)} type="button" class="edit-btn trash-icon-w icon-s mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                                    <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                                </svg>
                                            </button>
                                        }
                                        <button onClick={() => this.selectedNodeToDelete(this.props.node, 1)} type="button" class="edit-btn trash-icon-w icon-s" data-toggle="tooltip" data-placement="Delete" title="Delete"><i class="fa fa-trash"></i></button>
                                    </div> */}
                </div>
              </div>
              <div id={`collapseOne${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                {/* For MCQ Task */}
                {this.props.node.task_type === 1 ? (
                  <div class="card-body cus_border_E">
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-dark dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler9}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoCorrect${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle9On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}
                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Option 1 (Correct) : {this.props.node.task[0].correct}
                          </h6>
                        </div>
                        {/* <div>
                                                    <button onClick={() => this.props.subTaskPlusClick(this.props.node, "M_C")} type="button" class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>
                      <div
                        id={`collapseTwoCorrect${randomno}`}
                        class="collapse"
                        aria-labelledby={`headingOne${randomno}`}
                      >
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler8}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoAlt1${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle8On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}

                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Option 2 (Wrong) : {this.props.node.task[0].alternative_1}
                          </h6>
                        </div>
                        {/* <div>
                                                    <button onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A1")} type="button" class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>
                      <div id={`collapseTwoAlt1${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                        {this.props.node.task[0].a1Action.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>
                    {this.props.node.task[0].mcq_type === 1 ? (
                      <div class="card pc-card card-top-cont" id="q1">
                        <div class="mb-0 text-white dv-center space-between">
                          <div class="dv-center">
                            {this.props.node.task[0].correctAction?.length > 0 && (
                              <button
                                onClick={this.toggleHandler7}
                                class="btn btn-link text-dark arrow-s"
                                type="button"
                                data-toggle="collapse"
                                data-target={`#collapseTwoAlt2${randomno}`}
                                aria-expanded="true"
                                aria-controls={`#collapseOne${randomno}`}
                              >
                                <i className={this.state.isToggle7On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                              </button>
                            )}

                            <h6
                              class={`text-dark mb-0 ${
                                this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                              }`}
                            >
                              {" "}
                              Option 3 (Wrong) : {this.props.node.task[0].alternative_2}
                            </h6>
                          </div>
                          {/* <div>
                                                        <button type="button" onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A2")} class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                    </div> */}
                        </div>
                        <div
                          id={`collapseTwoAlt2${randomno}`}
                          class="collapse"
                          aria-labelledby={`headingOne${randomno}`}
                        >
                          {this.props.node.task[0].a2Action.map((list, index) => (
                            <SubTask
                              list={list}
                              editTasks={this.props.editTasks}
                              deleteTasks={this.selectedNodeToDelete}
                              deleteSubTasks={this.deleteSubTasks}
                              deleteTasksTypeFour={this.deleteTasksTypeFour}
                            />
                          ))}
                        </div>
                      </div>
                    ) : null}
                    {this.props.node.task[0].mcq_type === 1 ? (
                      <div class="card pc-card card-top-cont" id="q1">
                        <div class="mb-0 text-white dv-center space-between">
                          <div class="dv-center">
                            {this.props.node.task[0].correctAction?.length > 0 && (
                              <button
                                onClick={this.toggleHandler6}
                                class="btn btn-link text-dark arrow-s"
                                type="button"
                                data-toggle="collapse"
                                data-target={`#collapseTwoAlt3${randomno}`}
                                aria-expanded="true"
                                aria-controls={`#collapseOne${randomno}`}
                              >
                                <i className={this.state.isToggle6On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                              </button>
                            )}

                            <h6
                              class={`text-dark mb-0 ${
                                this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                              }`}
                            >
                              Option 4 (Wrong) : {this.props.node.alternative_3}
                            </h6>
                          </div>
                          {/* <div>
                                                        <button type="button" onClick={() => this.props.subTaskPlusClick(this.props.node, "M_A3")} class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                    </div> */}
                        </div>
                        <div
                          id={`collapseTwoAlt3${randomno}`}
                          class="collapse"
                          aria-labelledby={`headingOne${randomno}`}
                        >
                          {this.props.node.task[0].a3Action.map((list, index) => (
                            <SubTask
                              list={list}
                              editTasks={this.props.editTasks}
                              deleteTasks={this.selectedNodeToDelete}
                              deleteSubTasks={this.deleteSubTasks}
                              deleteTasksTypeFour={this.deleteTasksTypeFour}
                            />
                          ))}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null}
                {/* For Range Task */}
                {this.props.node.task_type === 2 ? (
                  <div class="card-body cus_border_E">
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler5}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRMax${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle5On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}

                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Maximum Value: {this.props.node.task[0].max_value}
                          </h6>
                        </div>
                        {/* <div>
                                                    <button type="button" onClick={() => this.props.subTaskPlusClick(this.props.node, "R_Max")} class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>
                      <div id={`collapseTwoRMax${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                        {this.props.node.task[0].maxAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler4}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRC${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle4On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}
                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Correct Value
                          </h6>
                        </div>
                        {/* <div>
                                                    <button type="button" onClick={() => this.props.subTaskPlusClick(this.props.node, "R_C")} class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>
                      <div id={`collapseTwoRC${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler3}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoRMIN${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle3On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}
                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Minimum Value: {this.props.node.task[0].min_value}
                          </h6>
                        </div>
                        {/* <div>
                                                    <button type="button" onClick={() => this.props.subTaskPlusClick(this.props.node, "R_Min")} class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>
                      <div id={`collapseTwoRMIN${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                        {this.props.node.task[0].minAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteSubTasks={this.deleteSubTasks}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>

                    {/* {node} */}
                  </div>
                ) : null}
                {/* For parent child Task */}
                {this.props.node.task_type === 3 ? (
                  <div class="card-body cus_border_E">
                    {/* <div class="card-body cus_border_E"> */}
                    <div class="card pc-card card-top-cont" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center">
                          {this.props.node.task[0].correctAction?.length > 0 && (
                            <button
                              onClick={this.toggleHandler2}
                              class="btn btn-link text-dark arrow-s"
                              type="button"
                              data-toggle="collapse"
                              data-target={`#collapseTwoPC${randomno}`}
                              aria-expanded="true"
                              aria-controls={`#collapseOne${randomno}`}
                            >
                              <i className={this.state.isToggle2On ? "fa fa-chevron-right" : "fa fa-chevron-up"}></i>
                            </button>
                          )}
                          <h6
                            class={`text-dark mb-0 ${
                              this.props.node.task[0].correctAction?.length > 0 ? "" : "pl-4 py-2"
                            }`}
                          >
                            {" "}
                            Complete Action{" "}
                          </h6>
                        </div>
                        {/* <div>
                                                    <button onClick={() => this.props.subTaskPlusClick(this.props.node, "P_C")} type="button" class="edit-btn" data-toggle="tooltip" data-placement="top" title="Add" id="stp3-btn"><i class="mdi mdi-plus"></i></button>
                                                </div> */}
                      </div>

                      <div id={`collapseTwoPC${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                        {this.props.node.task[0].correctAction.map((list, index) => (
                          <SubTask
                            list={list}
                            editTasks={this.props.editTasks}
                            deleteTasks={this.selectedNodeToDelete}
                            deleteTasksTypeFour={this.deleteTasksTypeFour}
                          />
                        ))}
                      </div>
                    </div>
                    {/* </div> */}
                    <div class="card pc-card" id="q1">
                      <div class="mb-0 text-white dv-center space-between">
                        <div class="dv-center"></div>
                      </div>
                      {this.props.node.task[0].children.map((childlist, childindex) => (
                        <ParentChildSubTask
                          node={childlist}
                          children={childlist.children}
                          editTasks={this.props.editTasks}
                          index={childindex}
                          showchild={false}
                        />
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ParentChildSubTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: true,
    };
  }
  toggleHandler = () => {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  };
  render() {
    var node;
    if (this.props.node) {
      if ("task" in this.props.node) {
        if (this.props.node.task[0].hasOwnProperty("children")) {
          node = this.props.node.task[0].children.map((childlist, childindex) => (
            <ParentChildSubTask
              node={childlist}
              children={childlist.children}
              editTasks={this.props.editTasks}
              index={childindex}
              showchild={false}
            />
          ));
        }
      }
    }

    //  this.props.node.task[0].children != undefined ? this.props.node.task[0].children.map((childlist, childindex) => <ParentChildSubTask node={childlist} children={childlist.children} index={childindex} />) : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);

    return (
      <div>
        <div class="accordion" id="accordion_task">
          <div class="stp2 mb-3">
            <div class="form-content pl-3 pr-3">
              {this.props.node.task_type == 3 ? (
                <div class="card mt-2 ml-3 mr-3 p-child" id="in-q1">
                  <div class="mb-0 text-dark dv-center space-between pt-2 pb-2">
                    <div class="dv-center ">
                      <button
                        onClick={this.toggleHandler}
                        className="btn btn-link text-dark arrow-s"
                        type="button"
                        data-toggle="collapse"
                        data-target={`#collapseOne${randomno}`}
                        aria-expanded="true"
                        aria-controls={`#collapseOne${randomno}`}
                      >
                        <i className={this.state.isToggleOn ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                      </button>

                      <i class="fa fa-sitemap"></i>
                      <h6 class="text-dark mb-0">{this.props.node.task[0].question}</h6>
                    </div>
                    {/* {this.props.showchild && this.props.node.parent_id == 0 ?
                                            <div>
                                                <button type="button" class="edit-btn trash-icon-b" onClick={() => this.props.deleteSubTasks(this.props.node, 2)} data-toggle="tooltip" data-placement="top" title="Edit"><i class="fa fa-trash"></i></button>
                                            </div>
                                            : null} */}
                  </div>
                </div>
              ) : null}
              {this.props.node.task_type == 1 ? (
                <div class="card mt-2 ml-3 mr-3" id="in-q1">
                  <div class="mb-0 pb-2 text-dark dv-center space-between p-c-cont">
                    <div class="dv-center justify-content-between">
                      <div class="dv-center">
                        <h6 class="text-dark mb-0 pl-3 pr-3 pt-3">
                          <span class="mr-2">
                            <i class="fa fa-th-list"></i>
                          </span>{" "}
                          {this.props.node.task[0].question}
                        </h6>
                      </div>
                      {this.props.node.is_mandatory ? (
                        <a class="badge badge-success mr-2">Compulsory</a>
                      ) : (
                        <a class="badge badge-danger text-white mr-2">Non-Compulsory</a>
                      )}

                      {/* <button onClick={() => this.props.editTasks(this.props.node)} type="button" class="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                                    <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                                </svg>
                                            </button> */}
                    </div>
                    <div className="cont-4-card tbl">
                      <div className="inner-cont">{this.props.node.task[0].correct}</div>
                      <div className="inner-cont">{this.props.node.task[0].alternative_1}</div>

                      {this.props.node.task[0].mcq_type === 2 ? null : (
                        <div className="inner-cont">{this.props.node.task[0].alternative_2}</div>
                      )}
                      {this.props.node.task[0].mcq_type === 2 ? null : (
                        <div className="inner-cont">{this.props.node.task[0].alternative_3}</div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null}
              {this.props.node.task_type == 2 ? (
                <div class="card mt-2 ml-3 mr-3 " id="in-q1">
                  <div class="mb-0 pb-2 text-dark dv-center space-between p-c-cont">
                    <div class="dv-center justify-content-between">
                      <div class="dv-center">
                        <h6 class="text-dark mb-0 pl-3 pr-3 pt-3">
                          <span class="mr-2">
                            <i class="fa fa-sort-numeric-asc"></i>
                          </span>{" "}
                          {this.props.node.task[0].question}
                        </h6>
                      </div>
                      {this.props.node.is_mandatory ? (
                        <a class="badge badge-success mr-2">Compulsory</a>
                      ) : (
                        <a class="badge badge-danger text-white mr-2">Non-Compulsory</a>
                      )}

                      {/* <button onClick={() => this.props.editTasks(this.props.node)} type="button" class="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                                <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                                    <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                                </svg>
                                            </button> */}
                    </div>
                    <div className="cont-4-card tbl">
                      <div className="inner-cont">{this.props.node.task[0].min_value}</div>
                      <div className="inner-cont">{this.props.node.task[0].max_value}</div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div id={`collapseOne${randomno}`} class="collapse " aria-labelledby={`headingOne${randomno}`}>
                {/* {this.props.node.task[0].children ? */}
                {node}
                {/* : null} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class SubTask extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    var list = this.props.list;
    return (
      <div>
        {list.task_type === 1 ? (
          <div class="card mt-2 ml-3 mr-3 pb-2" id="in-q1">
            <div class="mb-0 pb-2 text-dark dv-center space-between">
              <div class="dv-center">
                <h6 class="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span class="mr-2">
                    <i class="fa fa-th-list"></i>
                  </span>{" "}
                  {list.task[0].question}
                </h6>
              </div>
              {list.is_mandatory ? (
                <a class="badge badge-success mr-2">Compulsory</a>
              ) : (
                <a class="badge badge-danger text-white mr-2">Non-Compulsory</a>
              )}

              {/* <div style={{ transform: "translate(-7px, 8px)" }}>
                                <button onClick={() => this.props.editTasks(list)} type="button" class="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                        <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                    </svg>
                                </button>
                                <button type="button" class="edit-btn trash-icon-b icon-b" onClick={() => this.props.deleteTasks(list, 2)} data-toggle="tooltip" data-placement="top" title="Delete"><i class="fa fa-trash"></i></button>
                            </div> */}
            </div>
            <div className="cont-4-card tbl">
              <div className="inner-cont">{list.task[0].correct}</div>
              <div className="inner-cont">{list.task[0].alternative_1}</div>
              {list.task[0].mcq_type === 2 ? null : <div className="inner-cont">{list.task[0].alternative_2}</div>}
              {list.task[0].mcq_type === 2 ? null : <div className="inner-cont">{list.task[0].alternative_3}</div>}
            </div>
          </div>
        ) : null}
        {list.task_type === 2 ? (
          <div class="card mt-2 ml-3 mr-3 pb-2" id="in-q1">
            <div class="mb-0 pb-2 text-dark dv-center space-between">
              <div class="dv-center">
                <h6 class="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span class="mr-2">
                    <i class="fa fa-sort-numeric-asc"></i>
                  </span>{" "}
                  {list.task[0].question}
                </h6>
              </div>
              <div style={{ transform: "translate(-7px, 8px)" }}>
                {list.is_mandatory ? (
                  <a class="badge badge-success mr-2">Compulsory</a>
                ) : (
                  <a class="badge badge-danger text-white mr-2">Non-Compulsory</a>
                )}

                {/* <button onClick={() => this.props.editTasks(list)} type="button" class="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                        <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                    </svg>
                                </button>
                                <button type="button" class="edit-btn trash-icon-b icon-b" onClick={() => this.props.deleteTasks(list, 2)} data-toggle="tooltip" data-placement="top" title="Delete"><i class="fa fa-trash"></i></button> */}
              </div>
            </div>
            <div className="cont-4-card tbl">
              <div className="inner-cont">{list.task[0].min_value}</div>
              <div className="inner-cont">{list.task[0].max_value}</div>
            </div>
          </div>
        ) : null}
        {list.task_type === 3 ? (
          <div>
            <ParentChildSubTask
              node={list}
              children={list.children}
              editTasks={this.props.editTasks}
              index={0}
              deleteSubTasks={this.props.deleteSubTasks}
              showchild={true}
            />
          </div>
        ) : null}
        {list.task_type === 4 ? (
          <div class="card mt-2 ml-3 mr-3" id="in-q1">
            <div class="mb-0 pb-3 text-dark dv-center space-between">
              <div class="dv-center">
                <h6 class="text-dark mb-0 pl-3 pr-3 pt-3">
                  <span class="mr-2">
                    <i class="fa fa-check-circle"></i>
                  </span>
                  Trigger To : {list.trigger_id}
                </h6>
              </div>
              <div style={{ transform: "translate(-7px, 8px)" }}>
                {/* <button onClick={() => this.props.editTasks(list)} type="button" class="edit-btn trash-icon-b icon-b mr-2" data-toggle="tooltip" data-placement="top" title="Edit">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-pencil" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z" />
                                        <path fill-rule="evenodd" d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z" />
                                    </svg>
                                </button> */}
                <button
                  type="button"
                  class="edit-btn trash-icon-b icon-b"
                  onClick={() => this.props.deleteTasksTypeFour(list, 2)}
                  data-toggle="tooltip"
                  data-placement="top"
                  title="Delete"
                >
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

class ParentChildTree extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isToggleOn: true,
    };
  }
  toggleHandler = () => {
    this.setState((state) => ({
      isToggleOn: !state.isToggleOn,
    }));
  };

  render() {
    var node = this.props.children
      ? this.props.children.map((li, index) => (
          <ParentChildTree
            node={li}
            children={li.children}
            index={index}
            addParentChild={this.props.addParentChild}
            radioParentChildBankSelect={this.props.radioParentChildBankSelect}
          />
        ))
      : null;
    var randomno = Math.floor(Math.random() * (999 - 100 + 1) + 100);
    return (
      <div>
        <div class="accordion o-f-y-h" id="accordion_task">
          <div class="stp2 ">
            <div class="form-content">
              <div class="bg-light-g">
                {this.props.node.child_type == 3 ? (
                  <div class="card pc-card" id="q1">
                    <div class="mb-0 text-white dv-center space-between">
                      <div class="dv-center">
                        <button
                          onClick={this.toggleHandler}
                          className="btn btn-link text-dark arrow-s"
                          type="button"
                          data-toggle="collapse"
                          data-target={`#collapseOne${randomno}`}
                          aria-expanded="true"
                          aria-controls={`#collapseOne${randomno}`}
                        >
                          <i className={this.state.isToggleOn ? "fa fa-angle-right" : "fa fa-angle-down"}></i>
                        </button>
                        {this.props.node.parent_id == 0 ? (
                          <div class="custom-control custom-radio custom-control-inline">
                            <input
                              type="radio"
                              id={`parent_child_list${randomno}`}
                              value={this.props.node.id}
                              name="parent_child_list"
                              onChange={(e) => this.props.radioParentChildBankSelect(e)}
                              class="custom-control-input"
                            />
                            <label class="custom-control-label" for={`parent_child_list${randomno}`}></label>
                          </div>
                        ) : null}
                        {/* <input type="radio" id={`parent_child_list${randomno}`} value={this.props.node.id} onChange={(e) => this.props.radioParentChildBankSelect(e)} name="parentChild" class="custom-control-input" /> */}
                        <h6 class="text-dark mb-0"> {this.props.node.question}</h6>
                      </div>
                      <div>
                        <button
                          onClick={() => this.props.addParentChild(this.props.node)}
                          type="button"
                          class="edit-btn"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Add"
                          id="stp3-btn"
                        >
                          <i class="mdi mdi-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.props.node.child_type == 1 ? (
                  <div class="card mt-2 ml-3 mr-3" id="in-q1">
                    <div class="mb-0 text-dark dv-center space-between">
                      <div class="dv-center">
                        {/* <button class="btn btn-link text-white" type="button" data-toggle="collapse" data-target={`#collapseOne${randomno}`} aria-expanded="true" aria-controls={`#collapseOne${randomno}`}>
                                                    <i class="fa fa-angle-down text-dark mr-1"></i>
                                                 </button> */}
                        <h6 class="text-dark mb-0 p-2">{this.props.node.question}</h6>
                      </div>
                      <div>
                        {/* <button onClick={() => this.props.addParentChild(this.props.node)} type="button" class="edit-btn text-dark" data-toggle="tooltip" data-placement="top" title="Add"><i class="mdi mdi-plus"></i></button> */}
                      </div>
                    </div>
                  </div>
                ) : null}
                {this.props.node.child_type == 2 ? (
                  <div class="card mt-2 ml-3 mr-3 mb-2" id="in-q1">
                    <div class="mb-0 text-dark dv-center space-between">
                      <div class="dv-center">
                        {/* <button class="btn btn-link text-white" type="button" data-toggle="collapse" data-target={`#collapseOne${randomno}`} aria-expanded="true" aria-controls={`#collapseOne${randomno}`}>
                                                    <i class="fa fa-angle-down text-dark mr-1"></i>
                                                </button> */}
                        <h6 class="text-dark mb-0 p-2"> {this.props.node.question} </h6>
                      </div>
                      <div>
                        {/* <button onClick={() => this.props.addParentChild(this.props.node)} type="button" class="edit-btn text-dark" data-toggle="tooltip" data-placement="top" title="Add"><i class="mdi mdi-plus"></i></button> */}
                      </div>
                    </div>
                  </div>
                ) : null}
                <div id={`collapseOne${randomno}`} class="collapse" aria-labelledby={`headingOne${randomno}`}>
                  {node}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData,
});

export default withRouter(connect(mapStateToProps)(CreateTaskBank));
